var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-test-file" },
    [
      _c("drop-uploader", {
        ref: "dropUploader",
        attrs: {
          action: _vm.URL.common.uploadStorage,
          accept: [
            "pdf",
            "xls",
            "xlsx",
            "doc",
            "docx",
            "jpg",
            "gif",
            "png",
            "tif",
            "msword",
            "ms-excel",
            "jpeg",
            "rtf"
          ],
          "file-format": _vm.fileFormat,
          "close-on-click-modal": false,
          multiple: false
        },
        on: { "upload-result-file": _vm.uploadResult }
      }),
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { width: "100%", height: "80%" },
          attrs: {
            "left-style": { "min-width": "550px", width: "50%" },
            "right-style": { "min-width": "550px", width: "50%" }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c(
              "div",
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_FileName2") +
                        (_vm.ocrTemplate.fileName || "")
                    )
                  )
                ]),
                _c(
                  "el-button",
                  {
                    staticStyle: { width: "110px", "margin-left": "5px" },
                    attrs: { type: "primary", no: "uploadFile" },
                    on: {
                      click: function($event) {
                        return _vm.$refs.dropUploader.triggeFileSelectWindow()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.UploadFile")))]
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "95%",
                  overflow: "auto",
                  border: "1px solid #cccccc",
                  "margin-top": "10px"
                }
              },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: { "label-position": "left", "label-width": "0px" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "input-from",
                        staticStyle: { height: "100%" },
                        attrs: { label: " " }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input-border",
                          attrs: {
                            "filter-chars": false,
                            type: "textarea",
                            clearable: ""
                          },
                          model: {
                            value: _vm.promptTxt,
                            callback: function($$v) {
                              _vm.promptTxt = $$v
                            },
                            expression: "promptTxt"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("template", { slot: "right" }, [
            _c(
              "div",
              { staticStyle: { height: "26px", "margin-top": "12px" } },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_IdentifyReturnResult")))
                ])
              ]
            ),
            _c(
              "div",
              { staticStyle: { border: "1px solid #cccccc", height: "95%" } },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "10px",
                      height: "100%",
                      "overflow-y": "auto"
                    }
                  },
                  [
                    _vm.ocrTemplate.resultJsonTableData &&
                    _vm.ocrTemplate.resultJsonTableData.length > 0 &&
                    _vm.ocrTemplate.resultJsonTableData[_vm.pageNum - 1]
                      .length > 0
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              border: "1px solid black",
                              height: "auto"
                            }
                          },
                          _vm._l(
                            _vm.ocrTemplate.resultJsonTableData[
                              _vm.pageNum - 1
                            ],
                            function(pair, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "list-style",
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "50%",
                                        display: "flex"
                                      },
                                      on: {
                                        click: function() {
                                          _vm.curFocus = pair[0][0]
                                          if (
                                            _vm.resultArray[_vm.pageNum - 1]
                                              .pointer
                                          ) {
                                            _vm.resultArray[
                                              _vm.pageNum - 1
                                            ].pointer.curFocus = pair[0][0]
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "50%",
                                            display: "flex",
                                            border: "1px solid black",
                                            padding: "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "align-self": "center"
                                              }
                                            },
                                            [_vm._v(_vm._s(pair[0][0]))]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "50%",
                                            display: "flex",
                                            border: "1px solid black",
                                            padding: "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "align-self": "center"
                                              }
                                            },
                                            [_vm._v(_vm._s(pair[0][1]))]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  pair[1]
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "50%",
                                            display: "flex"
                                          },
                                          on: {
                                            click: function() {
                                              _vm.curFocus = pair[1][0]
                                              if (
                                                _vm.resultArray[_vm.pageNum - 1]
                                                  .pointer
                                              ) {
                                                _vm.resultArray[
                                                  _vm.pageNum - 1
                                                ].pointer.curFocus = pair[1][0]
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "50%",
                                                display: "flex",
                                                border: "1px solid black",
                                                padding: "5px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "align-self": "center"
                                                  }
                                                },
                                                [_vm._v(_vm._s(pair[1][0]))]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                width: "50%",
                                                display: "flex",
                                                border: "1px solid black",
                                                padding: "5px"
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "align-self": "center"
                                                  }
                                                },
                                                [_vm._v(_vm._s(pair[1][1]))]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "50%",
                                            display: "flex"
                                          }
                                        },
                                        [
                                          _c("div", {
                                            staticStyle: {
                                              width: "100%",
                                              display: "flex",
                                              border: "1px solid black",
                                              padding: "5px"
                                            }
                                          })
                                        ]
                                      )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            [
              _c("el-pagination", {
                staticClass: "general-pagination",
                staticStyle: { position: "absolute", right: "200px" },
                attrs: {
                  "current-page": _vm.pageNum,
                  "pager-count": 5,
                  "page-size": 1,
                  layout: "prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { "margin-top": "50px" } }, [
            _c(
              "div",
              { staticStyle: { display: "inline-block" } },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "primary", no: "1" },
                    on: { click: _vm.recognitionHandler }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("CargoMsg.Cargo_Recognition")) + " "
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "primary", no: "1" },
                    on: {
                      click: function($event) {
                        return _vm.refreshHandler()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Refresh")) + " ")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "5px" },
                    attrs: { type: "primary", no: "1" },
                    on: {
                      click: function($event) {
                        return _vm.sampleHandler()
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          this.$t("CargoMsg.Cargo_PromptWords") +
                            _vm.$t("CargoMsg.Cargo_Sample")
                        ) +
                        " "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.promptWordDialog.visible,
            title:
              this.$t("CargoMsg.Cargo_PromptWords") +
              _vm.$t("CargoMsg.Cargo_Sample"),
            width: "700px",
            "close-on-click-modal": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.promptWordDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { staticStyle: { "margin-left": "50px" } },
                [
                  _c("el-form-item", [
                    _c("pre", {
                      staticStyle: {
                        "white-space": "pre-wrap",
                        "overflow-y": "auto",
                        "overflow-x": "hidden",
                        width: "600px",
                        height: "60vh",
                        "min-height": "300px"
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.promptWordDialog.promptWord)
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.promptWordDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }